import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('etend.token'),
    first_name: localStorage.getItem('etend.first_name'),
    last_name: localStorage.getItem('etend.last_name'),
    personal_code: localStorage.getItem('etend.personal_code'),
    email: localStorage.getItem('etend.email'),
    phone: localStorage.getItem('etend.phone'),
    picture: localStorage.getItem('etend.picture'),
    group: localStorage.getItem('etend.group'),
    warehouse_groups: localStorage.getItem('etend.warehouse_groups'),
    aside_collapsed: localStorage.getItem('etend.aside_collapsed'),
    show_user_block: localStorage.getItem('etend.show_user_block'),
    show_setup: localStorage.getItem('etend.show_setup'),
    show_users: localStorage.getItem('etend.show_users'),
    supplier_id: localStorage.getItem('etend.supplierId'),
    language: localStorage.getItem('etend.language'),
    request_terms: null,
    nestableItems:[
      {
        id: 1,
        name: 'Item 1',
        code: '20012',
        children: [],
      }, {
        id: 2,
        name: 'Item 2',
        code: '20013',
        children:[
          {
            id: 3,
            name: 'Item 3',
            code: '20014',
            children:[]
          },
          {
            id: 4,
            name: 'Item 4',
            code: '20015',
            children:[
              {
                id: 5,
                name: 'Item 5',
                code: '20016',
                children:[]
              }]
          },]
      },
      {
        id: 7,
        name: 'Item 6',
        code: '20017',
        children:[]
      },
      {
        id: 8,
        name: 'Item 7',
        code:'20018',
        children:[]
      },
    ],
    filters: [],
    page_size: JSON.parse(localStorage.getItem('etend.page_size')) || {},
  },
  getters: {
    aside_collapsed: state => {
      return state.aside_collapsed
    },
    email: state => {
      return state.email
    },
    is_logged_in: state => {
      if (state.token !== null) {
        api.post('/expire/', {token: state.token})
          .then(response => {
            if (response.data.request_terms) {
              state.request_terms = response.data.request_terms
            }
          })
      }
      return state.token !== null
    },
    first_name: state => {
      return state.first_name
    },
    language: state => {
      return state.language
    },
    last_name: state => {
      return state.last_name
    },
    personal_code: state => {
      return state.personal_code
    },
    picture: state => {
      return state.picture
    },
    phone: state => {
      return state.phone
    },
    warehouse_groups: state => {
      return state.warehouse_groups
    },
    show_setup: state => {
      return state.show_setup
    },
    show_users: state => {
      return state.show_users
    },
    show_user_block: state => {
      return state.show_user_block
    },
    user_name: state => {
      return state.first_name + ' ' + state.last_name
    },
    supplierId: state => {
      return state.supplierId
    },
    group: state => {
      return state.group
    },
    user_group: state => {
      return state.group.charAt(0).toUpperCase() + state.group.slice(1).toLowerCase()
    },
    page_size: (state) => (name) => {
      return state.page_size[name]
    },
  },
  mutations: {
    updateElements: (state, payload) => {
      state.nestableItems = payload;
    },
    log_in (state, data) {
      state.token = data.token
      state.first_name = data.user.first_name
      state.last_name = data.user.last_name
      state.personal_code = data.user.personal_code
      state.email = data.user.email
      state.phone = data.user.phone
      state.picture = data.user.picture
      state.group = data.user.group_label
      state.supplier_id = data.user.supplier
      localStorage.setItem('etend.token', data.token)
      localStorage.setItem('etend.first_name', data.user.first_name)
      localStorage.setItem('etend.last_name', data.user.last_name)
      localStorage.setItem('etend.personal_code', data.user.personal_code)
      localStorage.setItem('etend.email', data.user.email)
      localStorage.setItem('etend.supplierId', data.user.supplier)
      localStorage.setItem('etend.phone', data.user.phone)
      localStorage.setItem('etend.picture', data.user.picture)
      localStorage.setItem('etend.warehouse_groups', JSON.stringify(data.user.warehouse_groups_options))
      state.warehouse_groups = JSON.stringify(data.user.warehouse_groups_options)
      localStorage.setItem('etend.group', data.user.group_label)
      if (!localStorage.getItem('etend.language')) {
        localStorage.setItem('etend.language', 'et-EE')
        state.language = 'et-EE'
      } else {
        state.language = localStorage.getItem('etend.language')
      }
    },
    log_out (state) {
      state.token = null
      localStorage.removeItem('etend.token')
      state.filters.forEach(i => localStorage.removeItem(i))
      state.filters = []
      localStorage.removeItem('etend.page_size')
      state.page_size = {}
    },
    update (state, data) {
      state.first_name = data.first_name
      state.last_name = data.last_name
      state.personal_code = data.personal_code
      state.email = data.email
      state.supplier_id = data.supplier
      state.phone = data.phone
      state.picture = data.picture
      localStorage.setItem('etend.first_name', data.first_name)
      localStorage.setItem('etend.last_name', data.last_name)
      localStorage.setItem('etend.personal_code', data.personal_code)
      localStorage.setItem('etend.email', data.email)
      localStorage.setItem('etend.supplierId', data.supplier)
      localStorage.setItem('etend.phone', data.phone)
      localStorage.setItem('etend.picture', data.picture)
    },
    SET_LANGUAGE (state, newValue) {
      state.langauge = newValue
      localStorage.setItem('etend.language', newValue)
    },
    SET_ASIDE_COLLAPSED (state, newValue) {
      state.aside_collapsed = newValue
      localStorage.setItem('etend.aside_collapsed', newValue)
    },
    SET_SHOW_USER_BLOCK (state, newValue) {
      state.show_user_block = newValue
      localStorage.setItem('etend.show_user_block', newValue)
    },
    SET_SHOW_SETUP (state, newValue) {
      state.show_setup = newValue
      localStorage.setItem('etend.show_setup', newValue)
    },
    SET_SHOW_USERS (state, newValue) {
      state.show_users = newValue
      localStorage.setItem('etend.show_users', newValue)
    },
    SET_FILTERS (state, newValue) {
      let key = "etend.filters." + newValue.name
      if (state.filters.indexOf(key) === -1) {
        state.filters.push(key)
      }
      localStorage.setItem(key, JSON.stringify(newValue))
    },
    CLEAR_FILTERS (state, value) {
      let key = "etend.filters." + value
      state.filters = state.filters.filter(i => i !== key)
      localStorage.removeItem(key)
    },
    SET_PAGE_SIZE (state, newValue) {
      state.page_size[newValue.name] = newValue.page_size
      localStorage.setItem("etend.page_size", JSON.stringify(state.page_size))
    },
    SET_REQUEST_TERMS(state, value) {
      state.request_terms = value
    }
  },
  actions: {
    updateElements: ({ commit }, payload) => {
      commit("updateElements", payload);
    },
    setAsideCollapsed: ({commit, state}, newValue) => {
      commit('SET_ASIDE_COLLAPSED', newValue)
      return state.message
    },
    setLanguage: ({commit, state}, newValue) => {
      commit('SET_LANGUAGE', newValue)
      return state.message
    },
    setShowUserBlock: ({commit, state}, newValue) => {
      commit('SET_SHOW_USER_BLOCK', newValue)
      return state.message
    },
    setShowSetup: ({commit, state}, newValue) => {
      commit('SET_SHOW_SETUP', newValue)
      return state.message
    },
    setShowUsers: ({commit, state}, newValue) => {
      commit('SET_SHOW_USERS', newValue)
      return state.message
    },
    setFilters: ({ commit, state }, newValue) => {
      commit('SET_FILTERS', newValue)
      return state.filters
    },
    clearFilters: ({commit, state}, key) => {
      commit('CLEAR_FILTERS', key)
      return state.filters
    },
    setPageSize: ({commit, state}, newValue) => {
      commit('SET_PAGE_SIZE', newValue)
      return state.page_size
    },
    clearPageSize: ({commit, state}, key) => {
      commit('CLEAR_FILTERS', key)
      return state.page_size
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js